export const createSwapSuccessResult = txHash => ({
  ok: true,
  status: 'Swap successful!',
  statusType: 'success',
  txHash,
});

export const createSubmittedFailureResult = (txHash, error) => ({
  ok: false,
  submitted: true,
  finalized: true,
  status: 'Swap transaction failed',
  statusType: 'error',
  txHash,
  rawConfirmationError: typeof error === 'string' ? error : error ? JSON.stringify(error) : '',
});

export const createSubmittedUnknownResult = ({ txHash, explorerName, error }) => ({
  ok: false,
  submitted: true,
  finalityUnknown: true,
  status: `Swap transaction was submitted, but confirmation could not be verified yet. Check your wallet or ${explorerName} before retrying.`,
  statusType: 'info',
  txHash,
  rawConfirmationError: error?.message || String(error || ''),
});
